(function () {
  'use strict';

  if (window.__dcLandingLoaded) return;
  window.__dcLandingLoaded = true;

  /* ── Hero cycling ─────────────────────────────────────────── */
  class DCHero {
    constructor(el) {
      this.el = el;
      this.imgs = Array.from(el.querySelectorAll('.dc-hero__img'));
      this.metas = Array.from(el.querySelectorAll('.dc-hero__meta'));
      this.thumbs = Array.from(el.querySelectorAll('.dc-hero__thumb'));
      this.count = this.imgs.length;
      this.idx = 0;
      this.timer = null;
      if (!this.count) return;
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      this.start();
    }

    go(next) {
      this.imgs[this.idx].classList.remove('dc-active');
      this.metas[this.idx] && this.metas[this.idx].classList.remove('dc-active');
      this.thumbs[this.idx] && this.thumbs[this.idx].classList.remove('dc-active');

      this.idx = next;

      this.imgs[this.idx].classList.add('dc-active');
      this.metas[this.idx] && this.metas[this.idx].classList.add('dc-active');
      this.thumbs[this.idx] && this.thumbs[this.idx].classList.add('dc-active');

      this.start();
    }

    start() {
      clearInterval(this.timer);
      this.timer = setInterval(() => this.go((this.idx + 1) % this.count), 5000);
    }
  }

  /* ── Featured Drop cycling ────────────────────────────────── */
  class DCDrop {
    constructor(el) {
      this.el = el;
      this.imgs = Array.from(el.querySelectorAll('.dc-drop__img'));
      this.panels = Array.from(el.querySelectorAll('.dc-drop__panel'));
      this.dots = Array.from(el.querySelectorAll('.dc-drop__dot'));
      this.count = this.imgs.length;
      this.idx = 0;
      this.timer = null;
      if (!this.count) return;

      el.querySelector('.dc-drop__tap-prev')?.addEventListener('click', () => this.go(this.idx - 1));
      el.querySelector('.dc-drop__tap-next')?.addEventListener('click', () => this.go(this.idx + 1));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));

      el.querySelectorAll('.dc-drop__size-chip').forEach(chip => {
        chip.addEventListener('click', function () {
          const panel = this.closest('.dc-drop__panel');
          panel.querySelectorAll('.dc-drop__size-chip').forEach(c => c.classList.remove('dc-active'));
          this.classList.add('dc-active');
          if (this.dataset.variant) {
            const addBtn = panel.querySelector('.dc-drop__add-btn');
            if (addBtn) addBtn.dataset.variant = this.dataset.variant;
          }
        });
      });

      el.querySelectorAll('.dc-drop__add-btn').forEach(btn => {
        btn.addEventListener('click', async function () {
          if (this.classList.contains('dc-drop__add-btn--added')) return;
          const variantId = this.dataset.variant;
          if (!variantId) {
            const panel = this.closest('.dc-drop__panel');
            const chips = panel?.querySelector('.dc-drop__size-chips');
            if (chips) { chips.classList.add('dc-size-req'); setTimeout(() => chips.classList.remove('dc-size-req'), 550); }
            return;
          }
          this.disabled = true;
          const origText = this.textContent.trim();
          this.textContent = 'Adding…';
          try {
            const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
              .map(el => el.dataset.sectionId)
              .filter(Boolean);
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: sectionIds.join(',') })
            });
            if (!res.ok) throw new Error();
            const addResult = await res.json();
            this.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="margin-right:6px"><polyline points="20 6 9 17 4 12"/></svg>Added';
            this.classList.add('dc-drop__add-btn--added');
            this.disabled = false;
            fetch('/cart.js').then(r => r.json()).then(cart => {
              document.querySelectorAll('[data-cart-item-count]').forEach(el => { el.textContent = cart.item_count; });
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: { resource: cart, sourceId: 'dc-featured-drop', data: { source: 'dc-featured-drop', itemCount: cart.item_count, sections: addResult.sections } }
              }));
            });
            setTimeout(() => {
              this.textContent = origText;
              this.classList.remove('dc-drop__add-btn--added');
            }, 2000);
          } catch {
            this.textContent = origText;
            this.disabled = false;
          }
        });
      });

      this.start();
    }

    go(next) {
      const total = this.count;
      const n = ((next % total) + total) % total;

      this.imgs[this.idx].classList.remove('dc-active');
      this.panels[this.idx] && this.panels[this.idx].classList.remove('dc-active');

      const prevDot = this.dots[this.idx];
      if (prevDot) { prevDot.classList.remove('dc-active'); prevDot.classList.add('dc-past'); }

      this.idx = n;

      this.imgs[this.idx].classList.add('dc-active');
      this.panels[this.idx] && this.panels[this.idx].classList.add('dc-active');

      this.dots.forEach((d, i) => {
        d.classList.remove('dc-active', 'dc-past');
        if (i < this.idx) d.classList.add('dc-past');
        if (i === this.idx) d.classList.add('dc-active');
      });

      this.start();
    }

    start() {
      clearInterval(this.timer);
      this.timer = setInterval(() => this.go(this.idx + 1), 15000);
    }
  }

  /* ── Shop filter + sort ──────────────────────────────────── */
  function initShop(el) {
    if (el.dataset.shopInit) return;
    el.dataset.shopInit = '1';
    const grid = el.querySelector('.dc-shop__grid');
    const filters = Array.from(el.querySelectorAll('.dc-shop__filter'));
    const sortWrap = el.querySelector('[data-dc-sort]');
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll('.dc-pcard'));
    const maxVisible = parseInt(grid.dataset.max, 10) || 8;
    let currentSort = 'featured';

    function applyFilter(val) {
      const matching = val === 'all' ? cards : cards.filter(c => c.dataset.type === val);
      cards.forEach(c => { c.hidden = true; });
      matching.slice(0, maxVisible).forEach(c => { c.hidden = false; });
    }

    function applySort(val) {
      currentSort = val;
      const visible = cards.filter(c => !c.hidden);
      visible.sort((a, b) => {
        if (val === 'price-asc') return +a.dataset.price - +b.dataset.price;
        if (val === 'price-desc') return +b.dataset.price - +a.dataset.price;
        return +a.dataset.pos - +b.dataset.pos;
      });
      visible.forEach(c => grid.appendChild(c));
    }

    // Ensure cards beyond maxVisible are hidden on init
    // (Liquid already pre-hides them, this is a safety net)
    cards.forEach((c, i) => { c.hidden = i >= maxVisible; });

    filters.forEach(btn => {
      btn.addEventListener('click', () => {
        filters.forEach(b => b.classList.remove('dc-active'));
        btn.classList.add('dc-active');
        applyFilter(btn.dataset.filter);
        applySort(currentSort);
      });
    });

    if (sortWrap) {
      const sortBtn = sortWrap.querySelector('.dc-shop__sort-btn');
      const sortLabel = sortWrap.querySelector('.dc-shop__sort-label');
      const sortOpts = Array.from(sortWrap.querySelectorAll('.dc-shop__sort-opt'));
      if (!sortBtn) return;

      sortBtn.addEventListener('click', e => {
        e.stopPropagation();
        const isOpen = sortWrap.hasAttribute('data-open');
        sortWrap.toggleAttribute('data-open', !isOpen);
        sortBtn.setAttribute('aria-expanded', String(!isOpen));
      });

      sortOpts.forEach(opt => {
        opt.addEventListener('click', () => {
          sortOpts.forEach(o => o.classList.remove('dc-sort-active'));
          opt.classList.add('dc-sort-active');
          sortLabel.textContent = opt.textContent;
          sortWrap.removeAttribute('data-open');
          sortBtn.setAttribute('aria-expanded', 'false');
          applySort(opt.dataset.val);
        });
      });

      document.addEventListener('click', e => {
        if (!sortWrap.contains(e.target)) sortWrap.removeAttribute('data-open');
      });
    }
  }

  /* ── Quick View ──────────────────────────────────────────── */
  function initQuickView() {
    let selectedVariantId = null;
    let imgFront = '';
    let imgBack = '';
    let zoomed = false;
    let activeFace = 'front';
    const isMobileQV = () => window.matchMedia('(max-width: 768px)').matches;

    // Inject modal once (guard against double-load when dc-landing.js is included by multiple sections)
    if (document.getElementById('dc-qv-backdrop')) return;
    const tpl = document.createElement('div');
    tpl.innerHTML = `
      <div class="dc-qv-backdrop" id="dc-qv-backdrop" hidden>
        <div class="dc-qv" id="dc-qv" role="dialog" aria-modal="true">
          <button class="dc-qv__close" id="dc-qv-close" aria-label="Close quick view">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
          <div class="dc-qv__scroll">
            <div class="dc-qv__img-col">
              <div class="dc-qv__img-wrap">
                <div class="dc-zoom-wrap" id="dc-qv-zoom">
                  <img id="dc-qv-img" src="" alt="" loading="lazy">
                  <div class="dc-zoom-hint" id="dc-zoom-hint">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" style="margin-right:5px"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
                    <span id="dc-zoom-hint-text">Click to zoom</span>
                  </div>
                </div>
              </div>
              <div class="dc-qv__face-btns" id="dc-qv-face-btns">
                <button class="dc-qv__face-btn active" data-face="front" aria-label="View image 1">01</button>
                <button class="dc-qv__face-btn" data-face="back" aria-label="View image 2">02</button>
              </div>
            </div>
            <div class="dc-qv__info">
              <p class="dc-eyebrow" id="dc-qv-brand"></p>
              <h2 class="dc-qv__name" id="dc-qv-name"></h2>
              <div class="dc-qv__price-row">
                <span class="dc-qv__price" id="dc-qv-price"></span>
                <span class="dc-qv__was" id="dc-qv-was" style="display:none"></span>
              </div>
              <p class="dc-qv__desc" id="dc-qv-desc"></p>
              <div id="dc-qv-sizes-wrap">
                <p class="dc-qv__size-label">Size <span class="dc-qv__size-req" id="dc-qv-size-req">: select to continue</span></p>
                <div class="dc-qv__size-chips" id="dc-qv-chips"></div>
              </div>
              <button class="dc-qv__add" id="dc-qv-add" disabled>Add to bag</button>
              <a class="dc-qv__view-full" id="dc-qv-view-full" href="">View full details</a>
              <div class="dc-qv__trust">
                <div class="dc-qv__trust-item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>Ships from Canada</div>
                <div class="dc-qv__trust-item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>Free tracked shipping</div>
                <div class="dc-qv__trust-item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.75"/></svg>30-day hassle-free returns</div>
              </div>
            </div>
          </div>
        </div>
      </div>`;
    document.body.appendChild(tpl.firstElementChild);

    // Lightbox: two-element simultaneous slide for smooth swipe navigation
    const lbTpl = document.createElement('div');
    lbTpl.innerHTML = `<div id="dc-qv-lightbox"><button id="dc-qv-lb-close" type="button" aria-label="Close image"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button><div id="dc-lb-track"><img id="dc-qv-lb-img" src="" alt=""><img id="dc-qv-lb-img2" src="" alt=""></div><div class="dc-lb-dots" id="dc-qv-lb-dots"></div></div>`;
    document.body.appendChild(lbTpl.firstElementChild);
    const lbEl   = document.getElementById('dc-qv-lightbox');
    const lbImg  = document.getElementById('dc-qv-lb-img');
    const lbImg2 = document.getElementById('dc-qv-lb-img2');
    const lbDots = document.getElementById('dc-qv-lb-dots');
    let lbImages = [], lbIndex = 0;
    let lbTouchX = 0, lbTouchY = 0, lbDragging = false, lbSwipeDir = 0;
    const _lbLowPower = Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
    if (!_lbLowPower && lbImg && lbImg2) {
      lbImg.style.willChange = 'transform';
      lbImg2.style.willChange = 'transform';
    }
    const LB_DUR = 'transform 0.28s cubic-bezier(0.25,0.1,0.25,1)';

    function updateLbDots() {
      if (!lbDots) return;
      if (lbImages.length <= 1) { lbDots.hidden = true; return; }
      lbDots.hidden = false;
      lbDots.innerHTML = lbImages.map((_, i) =>
        `<span class="dc-lb-dot${i === lbIndex ? ' active' : ''}"></span>`
      ).join('');
    }

    function openLightbox() {
      if (!lbEl || !lbImg || !lbImg2) return;
      lbImages = [imgFront, imgBack].filter(Boolean);
      if (!lbImages.length) return;
      lbIndex = activeFace === 'back' && lbImages.length > 1 ? 1 : 0;
      const vw = lbEl.offsetWidth || window.innerWidth;

      lbImg.style.transition = 'none';
      lbImg.style.transform = 'translateX(0)';
      lbImg.src = lbImages[lbIndex];
      lbImg.alt = qvImg.alt;

      // Pre-park img2 with the other image already loaded
      const otherIdx = lbImages.length > 1 ? 1 - lbIndex : -1;
      lbImg2.style.transition = 'none';
      lbImg2.style.transform = `translateX(${vw}px)`;
      lbImg2.src = otherIdx >= 0 ? lbImages[otherIdx] : '';

      updateLbDots();
      lbEl.classList.add('open');
    }

    function closeLightbox() {
      if (lbEl) lbEl.classList.remove('open');
    }

    document.getElementById('dc-qv-lb-close')?.addEventListener('click', closeLightbox);
    lbEl?.addEventListener('click', e => {
      if (e.target === lbEl || e.target.id === 'dc-lb-track') closeLightbox();
    });

    lbEl?.addEventListener('touchstart', e => {
      if (e.touches.length > 1) return;
      lbTouchX = e.touches[0].clientX;
      lbTouchY = e.touches[0].clientY;
      lbDragging = true;
      lbSwipeDir = 0;
      lbImg.style.transition = 'none';
      lbImg2.style.transition = 'none';
    }, { passive: true });

    lbEl?.addEventListener('touchmove', e => {
      e.preventDefault();
      if (!lbDragging) return;
      const dx = e.touches[0].clientX - lbTouchX;
      const vw = lbEl.offsetWidth || window.innerWidth;
      const isForward = dx < 0;
      const adjIdx = isForward ? lbIndex + 1 : lbIndex - 1;
      const hasAdj = adjIdx >= 0 && adjIdx < lbImages.length;
      const dir = isForward ? 1 : -1;

      // Load adjacent image into img2 once direction is determined
      if (hasAdj && lbSwipeDir !== dir) {
        lbSwipeDir = dir;
        lbImg2.src = lbImages[adjIdx];
        lbImg2.style.transform = `translateX(${isForward ? vw : -vw}px)`;
      }

      // Drag primary image with finger; rubber-band at edges
      lbImg.style.transform = `translateX(${hasAdj ? dx : dx * 0.15}px)`;
      // Drag secondary image in tandem from its parked position
      if (hasAdj) lbImg2.style.transform = `translateX(${(isForward ? vw : -vw) + dx}px)`;
    }, { passive: false });

    lbEl?.addEventListener('touchend', e => {
      if (!lbDragging) return;
      lbDragging = false;
      const dx = e.changedTouches[0].clientX - lbTouchX;
      const dy = Math.abs(e.changedTouches[0].clientY - lbTouchY);
      const vw = lbEl.offsetWidth || window.innerWidth;
      const isForward = dx < 0;
      const nextIdx = isForward ? lbIndex + 1 : lbIndex - 1;

      if (Math.abs(dx) > 70 && dy < 120 && nextIdx >= 0 && nextIdx < lbImages.length) {
        // Commit swipe: update index immediately so rapid swipes read the correct value
        lbIndex = nextIdx;
        lbImg.style.transition = LB_DUR;
        lbImg.style.transform = `translateX(${isForward ? -vw : vw}px)`;
        lbImg2.style.transition = LB_DUR;
        lbImg2.style.transform = 'translateX(0)';
        setTimeout(() => {
          // Promote img2 to primary slot; pre-load next neighbor in committed direction
          lbImg.src = lbImg2.src;
          lbImg.style.transition = 'none';
          lbImg.style.transform = 'translateX(0)';
          lbImg2.style.transition = 'none';
          const afterIdx = isForward ? lbIndex + 1 : lbIndex - 1;
          const hasAfter = afterIdx >= 0 && afterIdx < lbImages.length;
          lbImg2.src = hasAfter ? lbImages[afterIdx] : '';
          lbImg2.style.transform = `translateX(${isForward ? vw : -vw}px)`;
          updateLbDots();
        }, 300);
      } else {
        // Snap back
        lbImg.style.transition = LB_DUR;
        lbImg.style.transform = 'translateX(0)';
        lbImg2.style.transition = LB_DUR;
        lbImg2.style.transform = `translateX(${isForward ? vw : -vw}px)`;
      }
    }, { passive: true });

    const backdrop = document.getElementById('dc-qv-backdrop');
    const qvModal = document.getElementById('dc-qv');
    const qvImg = document.getElementById('dc-qv-img');
    const zoomWrap = document.getElementById('dc-qv-zoom');
    const zoomHint = document.getElementById('dc-zoom-hint');
    const zoomHintText = document.getElementById('dc-zoom-hint-text');
    const addBtn = document.getElementById('dc-qv-add');
    const faceBtns = document.getElementById('dc-qv-face-btns');

    function closeQV() {
      const lockY = parseInt(backdrop.dataset.lockY || '0', 10);
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo({ top: lockY, behavior: 'instant' });
      backdrop.setAttribute('hidden', '');
      selectedVariantId = null;
      zoomed = false;
      qvImg.style.transform = 'scale(1)';
      qvImg.style.transformOrigin = '50% 50%';
      zoomWrap.classList.remove('dc-zoom-wrap--zoomed');
      if (zoomHintText) zoomHintText.textContent = 'Click to zoom';
      closeLightbox();
    }

    document.getElementById('dc-qv-close').addEventListener('click', closeQV);
    backdrop.addEventListener('click', e => { if (e.target === backdrop) closeQV(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !backdrop.hidden) closeQV(); });

    // Front/Back toggle
    qvModal.querySelectorAll('.dc-qv__face-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        qvModal.querySelectorAll('.dc-qv__face-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        activeFace = btn.dataset.face;
        qvImg.src = btn.dataset.face === 'back' ? (imgBack || imgFront) : imgFront;
        zoomed = false;
        qvImg.style.transform = 'scale(1)';
        qvImg.style.transformOrigin = '50% 50%';
        zoomWrap.classList.remove('dc-zoom-wrap--zoomed');
        if (zoomHintText) zoomHintText.textContent = 'Click to zoom';
      });
    });

    // Zoom: click to toggle (desktop) / tap to lightbox (mobile)
    zoomWrap.addEventListener('click', () => {
      if (isMobileQV()) { openLightbox(); return; }
      zoomed = !zoomed;
      zoomWrap.classList.toggle('dc-zoom-wrap--zoomed', zoomed);
      if (zoomed) {
        qvImg.style.transition = 'transform 0.08s ease';
        qvImg.style.transform = 'scale(2.5)';
        if (zoomHintText) zoomHintText.textContent = 'Click to exit zoom';
      } else {
        qvImg.style.transformOrigin = '50% 50%';
        qvImg.style.transition = 'transform 0.3s ease';
        qvImg.style.transform = 'scale(1)';
        if (zoomHintText) zoomHintText.textContent = 'Click to zoom';
      }
    });
    zoomWrap.addEventListener('mouseleave', () => {
      if (zoomed) qvImg.style.transformOrigin = '50% 50%';
    });
    zoomWrap.addEventListener('mousemove', e => {
      if (!zoomed) return;
      const r = zoomWrap.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width * 100).toFixed(1);
      const y = ((e.clientY - r.top) / r.height * 100).toFixed(1);
      qvImg.style.transformOrigin = `${x}% ${y}%`;
    });

    // Add to bag
    addBtn.addEventListener('click', async () => {
      if (!selectedVariantId || addBtn.disabled || addBtn.classList.contains('added')) return;
      addBtn.textContent = 'Adding…';
      addBtn.disabled = true;
      try {
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map(el => el.dataset.sectionId)
          .filter(Boolean);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: selectedVariantId, quantity: 1, sections: sectionIds.join(',') })
        });
        if (!res.ok) throw new Error();
        const addResult = await res.json();
        addBtn.innerHTML = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><polyline points="20 6 9 17 4 12"/></svg> Added to bag`;
        addBtn.classList.add('added');
        addBtn.disabled = false;
        fetch('/cart.js').then(r => r.json()).then(cart => {
          document.querySelectorAll('[data-cart-item-count]').forEach(el => { el.textContent = cart.item_count; });
          // Match the theme's CartUpdateEvent shape (events.js) so
          // cart-icon and other listeners read the correct count.
          const evt = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'dc-quick-view',
              data: { source: 'dc-quick-view', itemCount: cart.item_count, sections: addResult.sections },
            },
          });
          document.dispatchEvent(evt);
        });
        setTimeout(closeQV, 1200);
      } catch {
        addBtn.textContent = 'Add to bag';
        addBtn.disabled = false;
      }
    });

    // Open
    function openQV(card) {
      const title = card.dataset.qvTitle || '';
      const brand = card.dataset.qvBrand || '';
      const price = card.dataset.qvPrice || '';
      const compare = card.dataset.qvCompare || '';
      const desc = card.dataset.qvDesc || 'Premium piece, hand-picked by DripConnect.';
      imgFront = card.dataset.qvImage || '';
      // No second image = no toggle. Never fall back to the front image: that
      // showed the same photo twice (and doubled the lightbox slides).
      imgBack = card.dataset.qvImageBack || '';
      const url = card.dataset.qvUrl || '';
      let variants = [];
      try { variants = JSON.parse(card.dataset.qvVariants || '[]'); } catch { /* empty */ }

      // Reset
      selectedVariantId = null;
      addBtn.disabled = true;
      addBtn.textContent = 'Add to bag';
      addBtn.classList.remove('added');
      qvModal.querySelectorAll('.dc-qv__face-btn').forEach((b, i) => b.classList.toggle('active', i === 0));
      if (faceBtns) faceBtns.hidden = !imgBack;
      activeFace = 'front';
      qvImg.src = imgFront;
      qvImg.alt = title;
      qvImg.style.transform = 'scale(1)';
      qvImg.style.transformOrigin = '50% 50%';
      zoomHint.hidden = false;
      zoomed = false;

      document.getElementById('dc-qv-brand').textContent = brand;
      document.getElementById('dc-qv-name').textContent = title;
      document.getElementById('dc-qv-price').textContent = price;
      const wasEl = document.getElementById('dc-qv-was');
      wasEl.textContent = compare;
      wasEl.style.display = compare ? '' : 'none';
      document.getElementById('dc-qv-desc').textContent = desc;
      document.getElementById('dc-qv-view-full').href = url;

      // Size chips
      const sizesWrap = document.getElementById('dc-qv-sizes-wrap');
      const chipsEl = document.getElementById('dc-qv-chips');
      const sizeReq = document.getElementById('dc-qv-size-req');
      const real = variants.filter(v => v.title !== 'Default Title');

      chipsEl.innerHTML = '';
      if (real.length === 0) {
        sizesWrap.hidden = true;
        if (variants[0]) { selectedVariantId = variants[0].id; addBtn.disabled = false; }
      } else {
        sizesWrap.hidden = false;
        sizeReq.style.display = '';
        real.forEach(v => {
          const chip = document.createElement('button');
          chip.className = 'dc-qv__size-chip' + (v.available ? '' : ' dc-qv__size-chip--oos');
          chip.textContent = v.title;
          chip.disabled = !v.available;
          chip.addEventListener('click', () => {
            chipsEl.querySelectorAll('.dc-qv__size-chip').forEach(c => c.classList.remove('active'));
            chip.classList.add('active');
            selectedVariantId = v.id;
            sizeReq.style.display = 'none';
            addBtn.disabled = false;
          });
          chipsEl.appendChild(chip);
        });
      }

      const _lockY = window.scrollY;
      backdrop.dataset.lockY = _lockY;
      backdrop.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${_lockY}px`;
      document.body.style.width = '100%';
    }

    // Block ALL touchmove on the dark overlay — this also catches scroll-chaining
    // that iOS propagates from inside the modal when it reaches its scroll extent
    backdrop.addEventListener('touchmove', e => {
      e.preventDefault();
    }, { passive: false });

    // Allow native scroll inside .dc-qv__scroll (the real overflow container — holds
    // both the image column and info column, esp. on mobile's single-column stack)
    // but stop it from chaining to the background
    const qvScrollEl = qvModal.querySelector('.dc-qv__scroll');
    if (qvScrollEl) {
      let _qvTouchY = 0;
      qvScrollEl.addEventListener('touchstart', e => {
        _qvTouchY = e.touches[0].clientY;
      }, { passive: true });
      qvScrollEl.addEventListener('touchmove', e => {
        const dy        = e.touches[0].clientY - _qvTouchY;
        _qvTouchY       = e.touches[0].clientY;
        const atTop     = qvScrollEl.scrollTop <= 0;
        const atBottom  = qvScrollEl.scrollTop + qvScrollEl.clientHeight >= qvScrollEl.scrollHeight - 1;
        if ((atTop && dy > 0) || (atBottom && dy < 0)) {
          e.preventDefault(); // at boundary — block chaining outright
        } else {
          e.stopPropagation(); // mid-scroll — let browser scroll natively, stop backdrop listener from running
        }
      }, { passive: false });
    }

    // Trigger delegation
    document.addEventListener('click', e => {
      const trigger = e.target.closest('[data-qv-trigger]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      const card = trigger.closest('.dc-pcard')
                || trigger.closest('[data-dc-hero]')?.querySelector('.dc-hero__img.dc-active')
                || trigger.closest('[data-dc-drop]')?.querySelector('.dc-drop__img.dc-active');
      if (card) openQV(card);
    });
  }

  /* ── VIP form ─────────────────────────────────────────────── */
  function initVIP(el) {
    const input = el.querySelector('.dc-vip__input');
    const btn = el.querySelector('.dc-vip__btn');
    const right = el.querySelector('.dc-vip__right');
    if (!input || !btn) return;

    function showSuccess() {
      right.innerHTML = `
        <div class="dc-vip__success">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="var(--gold-400)" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg>
          <h3 class="dc-vip__success-title">You're in.</h3>
          <p class="dc-vip__success-sub">Welcome to DripConnect VIP. Your first drop notification arrives Friday.</p>
        </div>`;
    }

    async function submit() {
      const email = input.value.trim();
      if (!email.includes('@') || !email.includes('.')) {
        input.style.borderColor = 'var(--danger-500)';
        input.focus();
        setTimeout(() => { input.style.borderColor = ''; }, 1600);
        return;
      }
      const origBtnText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Joining…';
      try {
        const fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[email]', email);
        fd.append('contact[tags]', 'newsletter,vip');
        fd.append('contact[accepts_marketing]', 'true');
        const res = await fetch('/contact', { method: 'POST', body: fd });
        if (!res.ok) throw new Error('VIP signup request failed');
        showSuccess();
      } catch (err) {
        console.error('[DC VIP] signup failed', err);
        btn.disabled = false;
        btn.textContent = origBtnText;
        input.style.borderColor = 'var(--danger-500)';
        setTimeout(() => { input.style.borderColor = ''; }, 1600);
      }
    }

    btn.addEventListener('click', submit);
    input.addEventListener('keydown', e => { if (e.key === 'Enter') submit(); });
  }

  /* ── Init ─────────────────────────────────────────────────── */
  function init() {
    document.querySelectorAll('[data-dc-hero]').forEach(el => new DCHero(el));
    document.querySelectorAll('[data-dc-drop]').forEach(el => new DCDrop(el));
    document.querySelectorAll('[data-dc-shop]').forEach(el => initShop(el));
    document.querySelectorAll('[data-dc-vip]').forEach(el => initVIP(el));
    initQuickView();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
